<template>
    <div id="hqmh">
        <headTop :id="id" @topback="topback"></headTop>
        <div class="banner" id="index">
            <img src="../../../static/images/qtbjt.png" alt="" style="width: 100%;">
        </div>
        <detailBread :breadName="'好动体育管理云平台'"></detailBread>
        <div class="container">
            <div class="page-title">
                好动体育管理云平台
            </div>
            <div class="page-content" style="text-align:left;width:1000px;margin:0 auto;">
                <p style=" margin: 20px 0;">针对高校体育事业开发的专注体育和体质健康信息化的产品。我们以促进国民体质健康为己任，致力构建以好动体育管理云平台为核心的体育相关产业生态圈。我们坚持以数据服务于学校体育教学与管理、激发学生的体育锻炼热情，进而推动全民健身运动，提高国民体质健康水平。</p>
                <p style=" font-size: 18px; font-weight: bold; margin: 20px 0;">一、体测成绩录入</p>
                <p style=" margin: 20px 0;">通过手机录成绩，随时随地更便捷。</p>
                <p style=" margin: 20px 0;">评分、等级、总分自动生成，上报更方便。</p>
                <p style=" font-size: 18px; font-weight: bold; margin: 20px 0;">二、在线理论考试</p>
                <p style=" margin: 20px 0;">系统自动出题、判分、保存成绩，省去人工出卷、排考、评阅卷，管理很轻松。</p>
                <p style=" font-size: 18px; font-weight: bold; margin: 20px 0;">三、体育考试成绩录入</p>
                <p style=" margin: 20px 0;">通过手机微信端，随时随地录成绩。</p>
                <p style=" margin: 20px 0;">自动评分、算总分、评级， 成绩汇总不再出错。</p>
                <p style=" font-size: 18px; font-weight: bold; margin: 20px 0;">四、任课班级成绩汇总</p>
                <p style=" margin: 20px 0;">成绩分布实时汇总，班上学生体质、教学情况一目了然。</p>
                <p style=" font-size: 18px; font-weight: bold; margin: 20px 0;">五、跑操情况查询</p>
                <p style=" margin: 20px 0;">教师可在后台查看学生的跑步次数、跑步路径等统计信息，掌握学生跑操情况。</p>
                <p style=" font-size: 18px; font-weight: bold; margin: 20px 0;">六、消息推送</p>
                <p style=" margin: 20px 0;">学校通知、考试安排、体育活动、各类赛事直接推送到每个学生手中，省时省力更轻松。</p>
                <p style=" font-size: 18px; font-weight: bold; margin: 20px 0;">七、决策分析</p>
                <p style=" margin: 20px 0;">原始数据自动汇总，保证数据及时、完整、准确。</p>
                <p style=" margin: 20px 0;">多维度分析统计，图文结合力求还原学生体质真相。</p>
                <p style=" margin: 20px 0;">体育管理、教学研究好帮手。</p>
            </div>
        </div>
    </div>
</template>
<script>
import headTop from '@/components/headTop'
import detailTop from '@/components/detailTop'
import detailBread from '@/components/detailBread'
export default {
    metaInfo: {
        title: '好动体育管理云平台', // set a title
        meta: [{             // set meta
            name: 'keyWords',
            content: '好动体育管理云平台'
        },
        {
            name: 'description',
            content: '好动体育管理云平台'
        }],
    },
    components:{
        detailTop,
        detailBread,
        headTop
    },
    data() {
        return {
            id:'3',
        }
    },
    methods: {
        topback(){
            this.$router.push({
                path:'/',
            })
        }
    },
    mounted() {
        $('html,body').animate({
            scrollTop: 0 + "px"
        }, {
            duration: 0,
            easing: "swing"
        });
        return false;
    },
    
}
</script>
<style scoped>
.page-content p {
    text-indent: 32px;
    font-size: 16px;
    line-height: 30px;
}
</style>


// WEBPACK FOOTER //
// src/pages/old/hdty.vue